module.exports = __webpack_public_path__ + "assets/img/block-ef563130.png";